const volcanes = {
  payingByMessage: 'ชำระเงินผ่าน ',
  safePaymentPage: 'หน้าเพจการชำระเงินที่ปลอดภัย',
  finishYourPaymentMessage: 'ชำระเงินให้เสร็จสิ้น ซื้อของคุณที่นี่ :)',
  inputCustomerName: 'ชื่อเต็ม',
  inputCustomerEmail: 'อีเมล',
  inputCustomerPhoneNumber: 'หมายเลขโทรศัพท์',
  inputCustumerPhoneNumberOptional: '(ไม่บังคับ)',
  emptyCardSecurityCode: 'กรุณากรอกรหัสความปลอดภัยของบัตร',
  invalidSecurityCode: 'รหัสความปลอดภัยไม่ถูกต้อง',
  invalidCvv: 'CVV ไม่ถูกต้อง',
  fieldCardSecurityCode: 'รหัสความปลอดภัย (CVV)',
  fieldCardHolderName: 'ชื่อเต็ม (ตามที่แสดงบนบัตร)',
  fieldCardExpiryDate: 'วันหมดอายุ',
  placeholderCardExpiryDate: 'ดด/ปปปป',
  fieldCardNumber: 'หมายเลขบัตร',
  fieldOneClickCardNumber: '{brand} ลงท้าย {lastFour}',
  transactionFeeTooltip: 'ค่าธรรมเนียมการดำเนินการ',
  total: 'รวม',
  amount: 'รายการ',
  termsLabel: 'เมื่อทำการชำระเงิน คุณยอมรับ',
  termsReferenceLink: 'ข้อกำหนดการให้บริการ',
  termsEbanxLabel: 'ของ EBANX',
  paymentPageTitle: 'หน้าชำระเงิน',
  selectPaymentMethod: 'เลือกวิธีการชำระเงิน',
  fatalErrorTitle: 'อุ๊ปส์!',
  fatalErrorMessage: 'ขออภัย เราไม่พบข้อมูลการชำระเงินของคุณ',
  fatalErrorFooter: 'การชำระเงินที่ปลอดภัยโดย',
  panamaUsdDisclaimer: 'Payments are processed via EBANX. Due to regional routing, your bank statement may reference Panama (PAB), which maintains a fixed 1:1 parity with USD. The final charge should reflect the USD price shown.',
  merchantPaymentCode: 'คำสั่งซื้อ #',
};

module.exports = volcanes;
